import { render, staticRenderFns } from "./SocialDetailsStudent.vue?vue&type=template&id=1a7494aa&scoped=true&"
import script from "./SocialDetailsStudent.vue?vue&type=script&lang=js&"
export * from "./SocialDetailsStudent.vue?vue&type=script&lang=js&"
import style0 from "./SocialDetailsStudent.vue?vue&type=style&index=0&id=1a7494aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7494aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCol,VRow,VSnackbar,VTextField,VToolbar,VToolbarTitle})
